import NonConformityTypes from "ContainersForm/NonConformity/types"

// ALL GETS BY TYPE
export const getFullAnomaliesAction = payload => ({
  type: NonConformityTypes.GET_FULL_ANOMALIES,
  payload,
})

export const getFullAnomaliesSuccessAction = payload => ({
  type: NonConformityTypes.GET_FULL_ANOMALIES_SUCCESS,
  payload,
})

export const getFullIncidentsAction = payload => ({
  type: NonConformityTypes.GET_FULL_INCIDENTS,
  payload,
})

export const getFullIncidentsSuccessAction = payload => ({
  type: NonConformityTypes.GET_FULL_INCIDENTS_SUCCESS,
  payload,
})

export const getFullAuditRecommendationsAction = payload => ({
  type: NonConformityTypes.GET_FULL_AUDIT_RECOMMENDATIONS,
  payload,
})

export const getFullAuditRecommendationsSuccessAction = payload => ({
  type: NonConformityTypes.GET_FULL_AUDIT_RECOMMENDATIONS_SUCCESS,
  payload,
})

// POST
export const createNonConformityAction = payload => ({
  type: NonConformityTypes.CREATE_NON_CONFORMITY,
  payload,
})

// PATCH
export const patchNonConformityAction = payload => ({
  type: NonConformityTypes.PATCH_NON_CONFORMITY,
  payload,
})
export const patchStatutNonConformityAction = payload => ({
  type: NonConformityTypes.PATCH_STATUT_NON_CONFORMITY,
  payload,
})

// DELETE
export const deleteNonConformityAction = payload => ({
  type: NonConformityTypes.DELETE_NON_CONFORMITY,
  payload,
})

// TASKS
export const validatedTaskAction = payload => ({
  type: NonConformityTypes.VALIDATED_TASK,
  payload,
})
